import React, { useState } from "react";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

// assets and scss import
import downloadicon from "../../../../assets/dashboard/download_icon.svg";
import filterIcon from "../../../../assets/Filter.svg";
import eyeIcon from "../../../../assets/eye-fill.svg";
import eyeHideIcon from "../../../../assets/eye-fill-hide.svg";
import rightArrow from "../../../../assets/Rightarrow.svg";
import leftArrow from "../../../../assets/Leftarrow.svg";
import "./dayCollectionHeaderView.scss";

// project file import
import DashboardDatePicker from "../../../common/Modules/DashboardDatePicker";

//constants import
import { formatDecimalNumber } from "../../../../Util/Helper/formatNumberWithDecimals";
import { MAINT, PROD, QA, UAT } from "../../../common/config";
import { DAY_COLLECTION_MIN_DATE } from "../../constants";

const DayCollectionHeaderView = ({
  showFlag,
  setShowFlag,
  date,
  totalSummaryAmount,
  handleDate,
  handleOpenFilter,
  displayTransactionDropdown,
  filterApplied,
  disableDayCollectionDownload,
  handleDownloadDayCollection,
}) => {
  const [openCalendar, setOpenCalendar] = useState(false);

  // handlers

  const handleOpenCalendar = () => {
    setOpenCalendar(!openCalendar);
  };

  const disablePrev = () => {
    if (moment(getMinDate()).isSame(moment(date))) {
      return true;
    }
    return false;
  };

  const disableNext = () => {
    let tomorrow = new Date(date);
    tomorrow.setDate(tomorrow.getDate() + 1);
    let dd = String(tomorrow.getDate()).padStart(2, "0");
    let yyyy = tomorrow.getFullYear();
    const month = moment(tomorrow).format("MMM");
    const updatedDate = `${month} ${dd}, ${yyyy}`;
    if (moment(updatedDate).isSameOrBefore(moment().add(1, "years"))) {
      return false;
    }
    return true;
  };

  const handlePreviousDate = () => {
    let prevDate = new Date(date);
    prevDate.setDate(prevDate.getDate() - 1);
    let dd = String(prevDate.getDate()).padStart(2, "0");
    let yyyy = prevDate.getFullYear();
    const month = moment(prevDate).format("MMM");
    const updatedDate = `${month} ${dd}, ${yyyy}`;
    handleDate(updatedDate);
  };

  const handleNextDate = () => {
    let tomorrow = new Date(date);
    tomorrow.setDate(tomorrow.getDate() + 1);
    let dd = String(tomorrow.getDate()).padStart(2, "0");
    let yyyy = tomorrow.getFullYear();
    const month = moment(tomorrow).format("MMM");
    const updatedDate = `${month} ${dd}, ${yyyy}`;
    handleDate(updatedDate);
  };

  const dateInputCallBack = (val) => {
    val.setDate(val.getDate());
    let dd = String(val.getDate()).padStart(2, "0");
    let yyyy = val.getFullYear();
    const month = moment(val).format("MMM");
    const updatedDate = `${month} ${dd}, ${yyyy}`;
    handleDate(updatedDate);
    setOpenCalendar(false);
  };

  const handleShow = () => {
    setShowFlag(true);
  };
  const handleHide = () => {
    setShowFlag(false);
  };

  const getMinDate = () => {
    if (process.env.REACT_APP_ENV === QA) {
      return new Date(DAY_COLLECTION_MIN_DATE.QA);
    } else if (process.env.REACT_APP_ENV === UAT) {
      return new Date(DAY_COLLECTION_MIN_DATE.UAT);
    } else if (
      process.env.REACT_APP_ENV === PROD ||
      process.env.REACT_APP_ENV === MAINT
    ) {
      return new Date(DAY_COLLECTION_MIN_DATE.PROD);
    } else {
      return new Date(DAY_COLLECTION_MIN_DATE.DEV);
    }
  };
  // display UI
  const TextOnlyTooltip = withStyles({
    tooltip: {
      bottom: "2px",
      color: "#1B2027",
      backgroundColor: "white",
      fontSize: "12px",
      boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    },
  })(Tooltip);
  const Backdrop = ({ onClick }) => (
    <div className="dchv-backdrop" onClick={onClick} />
  );
  const renderDatePicker = () => {
    return (
      <div className="dchv-calendar">
        <p onClick={handleOpenCalendar}>{date}</p>{" "}
        <img
          src={leftArrow}
          alt="Left"
          onClick={() => (disablePrev() ? null : handlePreviousDate())}
          className="dchv-calendar-left-arrow"
          style={{
            cursor: disablePrev() ? "not-allowed" : "pointer",
          }}
        />
        <img
          src={rightArrow}
          alt="Right"
          onClick={() => (disableNext() ? null : handleNextDate())}
          className="dchv-calendar-right-arrow"
          style={{
            cursor: disableNext() ? "not-allowed" : "pointer",
          }}
        />
        {openCalendar && (
          <>
            <Backdrop
              onClick={() => {
                setOpenCalendar(false);
              }}
            />

            <DashboardDatePicker
              dateInputCallBack={(val) => dateInputCallBack(val)}
              maxDate={moment(new Date()).add(12, "months")._d}
              minDate={getMinDate()}
              onCalendarMonthChange={() => {}}
            />
          </>
        )}
      </div>
    );
  };

  const displayTransactionDropdownUI = () => {
    return (
      <div className="dchv-my-transaction-dropdown">
        <h6>My Transactions </h6>
        {displayTransactionDropdown()}
      </div>
    );
  };

  const displayHeaderUI = () => {
    return (
      <nav>
        <div className="dchv-nav-left-ui">
          {window.innerWidth < 768 && displayTransactionDropdownUI()}
          {renderDatePicker()}
          {window.innerWidth > 768 ? (
            <h2>{showFlag ? "Collection Summary" : "Collection Details"}</h2>
          ) : (
            <h2>Collection Summary</h2>
          )}
        </div>
        <div className="dchv-nav-right-ui">
          {!showFlag && window.innerWidth > 768 && (
            <div className="dchv-nav-stats">
              <div className="dchv-nav-stats-div">
                <div className="dchv-nav-stats-label">Cash:</div>
                <div className="dchv-nav-stats-value">
                  {totalSummaryAmount?.sum_of_cash
                    ? `₹${formatDecimalNumber(totalSummaryAmount?.sum_of_cash)}`
                    : "₹0"}
                </div>
              </div>
              <div className="dchv-nav-stats-div">
                <div className="dchv-nav-stats-label">C2C Online:</div>
                <div className="dchv-nav-stats-value">
                  {totalSummaryAmount?.sum_of_online_amount
                    ? `₹${formatDecimalNumber(
                        totalSummaryAmount?.sum_of_online_amount
                      )}`
                    : "₹0"}
                </div>
              </div>
              <div className="dchv-nav-stats-div">
                <div className="dchv-nav-stats-label">Others:</div>
                <div className="dchv-nav-stats-value">
                  {totalSummaryAmount?.sum_of_other_amount
                    ? `₹${formatDecimalNumber(
                        totalSummaryAmount?.sum_of_other_amount
                      )}`
                    : "₹0"}
                </div>
              </div>
              <div className="dchv-nav-stats-div">
                <div className="dchv-nav-stats-label">Total:</div>
                <div className="dchv-nav-stats-value">
                  {totalSummaryAmount?.sum_of_total_calculated_amount
                    ? `₹${formatDecimalNumber(
                        totalSummaryAmount?.sum_of_total_calculated_amount
                      )}`
                    : "₹0"}
                </div>
              </div>
            </div>
          )}
          <div className="dchv-nav-buttons">
            <TextOnlyTooltip title={"Filter"}>
              <button
                className="dchv-nav-button  dchv-filter-icon"
                onClick={handleOpenFilter}
              >
                {filterApplied ? displayFilterApplied() : ""}
                <img src={filterIcon} alt="" />
              </button>
            </TextOnlyTooltip>

            <TextOnlyTooltip title={"Download Report"}>
              <button
                className="dchv-nav-button"
                disabled={disableDayCollectionDownload}
                onClick={handleDownloadDayCollection}
              >
                <img src={downloadicon} alt="" />
              </button>
            </TextOnlyTooltip>

            {showFlag ? (
              <TextOnlyTooltip title={"Show"}>
                <button
                  className="dchv-nav-button"
                  onClick={() => {
                    handleHide();
                  }}
                >
                  <img src={eyeIcon} alt="" />
                </button>
              </TextOnlyTooltip>
            ) : (
              <TextOnlyTooltip title={"Hide"}>
                <button
                  className="dchv-nav-button"
                  onClick={() => {
                    handleShow();
                  }}
                >
                  <img src={eyeHideIcon} alt="" />
                </button>
              </TextOnlyTooltip>
            )}
          </div>
        </div>
      </nav>
    );
  };

  const displayFilterApplied = () => {
    return <span className="dchv-subheader-filter-applied"></span>;
  };

  return <div className="day-collection-header-view">{displayHeaderUI()}</div>;
};

export default DayCollectionHeaderView;
